import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
    const { user, loading } = useUser();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="w-16 h-16 border-4 border-brand/20 border-t-brand rounded-full animate-spin" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/auth" replace />;
    }

    const checkIsAdmin = (userObj) => {
        return (
            userObj.is_staff === true ||
            userObj.is_staff === 1 ||
            userObj.is_staff === "true" ||
            userObj.is_superuser === true ||
            userObj.is_superuser === 1 ||
            userObj.is_superuser === "true" ||
            userObj.role === 'admin' ||
            userObj.user_type === 'admin'
        );
    };

    if (adminOnly && !checkIsAdmin(user)) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
